var Component = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MentoringAvatarStub.vue"),
  /* template */
  require("!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7be26d05\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringAvatarStub.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/MentoringAvatarStub.vue
// module id = 720748267503cf7935b3
// module chunks = 89